webpackJsonp([114276838955818,60335399758886],{

/***/ 147:
/***/ (function(module, exports) {

	module.exports = {"data":{"articleCategories":{"edges":[{"node":{"wordpress_id":1,"name":"Bez kategorii","slug":"bez-kategorii","count":0,"lang":"pl"}},{"node":{"wordpress_id":18,"name":"Identyfikacja","slug":"identyfikacja","count":22,"lang":"pl"}},{"node":{"wordpress_id":24,"name":"Inne","slug":"inne","count":2,"lang":"pl"}},{"node":{"wordpress_id":20,"name":"Marka","slug":"marka","count":29,"lang":"pl"}},{"node":{"wordpress_id":33,"name":"Other","slug":"other","count":0,"lang":"en"}},{"node":{"wordpress_id":22,"name":"Strategia","slug":"strategia","count":19,"lang":"pl"}},{"node":{"wordpress_id":7,"name":"Uncategorized","slug":"uncategorized","count":0,"lang":"en"}}]},"portfolioCategories":{"edges":[{"node":{"wordpress_id":39,"name":"Brand","slug":"brand","count":3,"lang":"en"}},{"node":{"wordpress_id":37,"name":"Identification","slug":"identification","count":3,"lang":"en"}},{"node":{"wordpress_id":26,"name":"Identyfikacja","slug":"identyfikacja","count":28,"lang":"pl"}},{"node":{"wordpress_id":114,"name":"identyfikacja wizualna","slug":"identyfikacja-wizualna","count":2,"lang":"pl"}},{"node":{"wordpress_id":27,"name":"Marka","slug":"marka","count":26,"lang":"pl"}},{"node":{"wordpress_id":28,"name":"Strategia","slug":"strategia","count":3,"lang":"pl"}},{"node":{"wordpress_id":41,"name":"Strategy","slug":"strategy","count":1,"lang":"en"}}]},"menu":{"edges":[{"node":{"lang":"pl","processedItems":[{"label":"Projekty","to":"/portfolio/","submenu":null},{"label":"Artykuły","to":"/artykuly/","submenu":null},{"label":"Oferta","to":"/oferta/","submenu":[{"label":"Analiza","to":"/oferta/analiza-marki/"},{"label":"Strategia","to":"/oferta/strategia-marketingowa/"},{"label":"Identyfikacja","to":"/oferta/identyfikacja-wizualna-corporate-identity/"}]},{"label":"My","to":"/my-czyli-studio-brandingowe/","submenu":null},{"label":"Kontakt","to":"/kontakt/","submenu":null}]}},{"node":{"lang":"en","processedItems":[{"label":"Work","to":"/en/portfolio/","submenu":null}]}}]},"options":{"footer_text":[{"kolumna":"<p><span style=\"color: #ffffff;\">POROZMAWIAJMY<br />\ni SKUPMY UWAGĘ<br />\nNA TWOJEJ MARCE!<br />\n</span></p>\n"},{"kolumna":"<p><span style=\"color: #ffffff;\">MARCIN GAJOS</span><br />\n<span style=\"color: #761b4a;\">Projekt Menadżer</span><br />\n<a href=\"tel:+48660671789\">+48 660 671 789</a><br />\n<a href=\"mailto:marcin@brandglow.pl\">marcin@brandglow.pl</a></p>\n"},{"kolumna":"<p><span style=\"color: #761b4a;\">BRANDGLOW SP. Z O.O.</span><br />\nul. Technologiczna 2<br />\n45-839 Opole<br />\n<a href=\"mailto:office@brandglow.pl\">office@brandglow.pl</a></p>\n"},{"kolumna":"<p><span style=\"text-decoration: underline;\"><a href=\"http://brandglow.pl/polityka-prywatnosci/\" target=\"_blank\" rel=\"noopener\">Polityka prywatności</a></span></p>\n"}],"social_media":[{"title":"Behance","link":"http://www.behance.net/brandglow","image":{"localFile":{"childImageSharp":{"original":{"width":45},"sizes":{"aspectRatio":1.5517241379310345,"src":"/static/225a1ca2c6c554fe296c7b4661d92ba7-b8967da0f38ac92035d944fc4b9067de-d46a8.png","srcWebp":"/static/225a1ca2c6c554fe296c7b4661d92ba7-b8967da0f38ac92035d944fc4b9067de-5ab81.webp"}}}}},{"title":"Facebook","link":"https://pl-pl.facebook.com/Brandglow","image":{"localFile":{"childImageSharp":{"original":{"width":21},"sizes":{"aspectRatio":0.5526315789473685,"src":"/static/f7145a99c7256d0c41a64c7395204cf5-ed8064d45c4144185726df200a07a8dd-352bb.png","srcWebp":"/static/f7145a99c7256d0c41a64c7395204cf5-ed8064d45c4144185726df200a07a8dd-2e60c.webp"}}}}},{"title":"Instagram","link":"https://www.instagram.com/brandglow/?hl=pl","image":{"localFile":{"childImageSharp":{"original":{"width":38},"sizes":{"aspectRatio":1,"src":"/static/b4934a25971663a145f954e1ecd95850-c83d2f9866da79bd87dd1a231e86b078-e2ead.png","srcWebp":"/static/b4934a25971663a145f954e1ecd95850-c83d2f9866da79bd87dd1a231e86b078-5f446.webp"}}}}}],"defaultOGImage":{"src":"/static/dac5344e445e9905257cc84ffa71ebe3-0e376dcc774a43e1fe27e5c897f19209-dd456.jpg","width":1600,"height":843}},"languages":{"edges":[{"node":{"lang":"pl"}}]}},"layoutContext":{}}

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(254);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(147);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(158);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _lazyImage = __webpack_require__(12);
	
	var _footerModule = __webpack_require__(393);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const { footer, footerLogo } = Styles
	
	var Footer = function (_React$PureComponent) {
	  _inherits(Footer, _React$PureComponent);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.footer },
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.flex },
	        _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.footerLogo },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            _react2.default.createElement(_logo2.default, { light: true, width: 203 })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.texts },
	          this.props.options.footer_text && this.props.options.footer_text.map(function (column_text, index) {
	            return _react2.default.createElement('div', {
	              className: _footerModule2.default.text,
	              key: index,
	              dangerouslySetInnerHTML: {
	                __html: column_text.kolumna
	              }
	            });
	          })
	        ),
	        this.props.options.social_media && _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.socialContainer },
	          this.props.options.social_media.map(function (smItem, index) {
	            return _react2.default.createElement(
	              'a',
	              {
	                href: smItem.link,
	                target: '_blank',
	                key: index,
	                rel: 'noopener',
	                className: _footerModule2.default.socialItem,
	                style: {
	                  width: smItem.image.localFile.childImageSharp.original.width
	                }
	              },
	              _react2.default.createElement(_lazyImage.Image, { sizes: smItem.image.localFile.childImageSharp.sizes })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.PureComponent);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _filterSort = __webpack_require__(40);
	
	var _filterSort2 = _interopRequireDefault(_filterSort);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list;
	
	var ArticleFilterSort = function (_FilterSort) {
	  _inherits(ArticleFilterSort, _FilterSort);
	
	  function ArticleFilterSort() {
	    _classCallCheck(this, ArticleFilterSort);
	
	    return _possibleConstructorReturn(this, _FilterSort.apply(this, arguments));
	  }
	
	  ArticleFilterSort.prototype.queriesToGlobalState = function queriesToGlobalState() {
	    return {
	      filter: 'articleFilter',
	      sort: 'articleSort',
	      archive: 'articleArchive'
	    };
	  };
	
	  ArticleFilterSort.prototype.renderContent = function renderContent() {
	    var _this2 = this;
	
	    var _parseQuery = (0, _filterSort.parseQuery)(this.props.location.search, {
	      filter: null,
	      sort: null,
	      archive: null
	    }),
	        sort = _parseQuery.sort,
	        filter = _parseQuery.filter,
	        archive = _parseQuery.archive;
	
	    var filterOptions = [{
	      label: (0, _stringTranslation.translate)('all'),
	      value: null
	    }].concat(_globalState2.default.state.articleCategories.filter(function (category) {
	      return category.lang === _this2.props.language;
	    }).map(function (category) {
	      return {
	        label: category.label,
	        value: category.slug
	      };
	    }));
	
	    var sortOptions = [{
	      label: (0, _stringTranslation.translate)('newest'),
	      value: null
	    }, {
	      label: (0, _stringTranslation.translate)('oldest'),
	      value: 'oldest'
	    }, {
	      label: (0, _stringTranslation.translate)('most_popular'),
	      value: 'most-popular'
	    }];
	
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(filterOptions, filter, 'articleFilter', 'filter')
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(sortOptions, sort, 'articleSort', 'sort')
	      )
	    );
	  };
	
	  return ArticleFilterSort;
	}(_filterSort2.default);
	
	exports.default = (0, _stateProvider2.default)((0, _reactRouter.withRouter)(ArticleFilterSort), function (state) {
	  return {
	    filter: state.articleFilter,
	    sort: state.articleSort,
	    archive: state.articleArchive,
	    language: state.language
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.parseQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _filterSort = __webpack_require__(57);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list,
	    item = _headerFilterSortModule2.default.item,
	    itemActive = _headerFilterSortModule2.default.itemActive;
	
	var FilterSort = function (_React$PureComponent) {
	  _inherits(FilterSort, _React$PureComponent);
	
	  function FilterSort(props) {
	    _classCallCheck(this, FilterSort);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.listenHistory = _this.listenHistory.bind(_this);
	    _this.queriesToGlobalStateMap = _this.queriesToGlobalState();
	    return _this;
	  }
	
	  FilterSort.prototype.renderOptions = function renderOptions(options, current, stateKey, propKey) {
	    var _this2 = this;
	
	    var qArgs = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      qArgs[key] = this.props[key];
	    }
	
	    return options.map(function (option) {
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.value,
	          className: current === option.value ? itemActive : item,
	          onClick: function onClick() {
	            var _extends2;
	
	            var q = (0, _filterSort.buildQuery)(_extends({}, qArgs, (_extends2 = {}, _extends2[propKey] = option.value, _extends2)), true);
	
	            if (option.value !== current) {
	              var _globalState$setState;
	
	              window.___gatsbyNavigateTo('' + _this2.props.location.pathname + q);
	
	              _globalState2.default.setState((_globalState$setState = {}, _globalState$setState[stateKey] = option.value, _globalState$setState));
	            }
	          }
	        },
	        option.label
	      );
	    });
	  };
	
	  FilterSort.prototype.componentDidMount = function componentDidMount() {
	    this.setGlobalStateFromPath(this.props.location.search);
	    this.unlistenHistory = this.props.history.listen(this.listenHistory);
	  };
	
	  FilterSort.prototype.listenHistory = function listenHistory(location) {
	    this.setGlobalStateFromPath(location.search);
	  };
	
	  FilterSort.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlistenHistory();
	  };
	
	  FilterSort.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    this.setGlobalStateFromPath(nextProps.location.search);
	  };
	
	  FilterSort.prototype.setGlobalStateFromPath = function setGlobalStateFromPath(getQuery) {
	    var initial = {};
	    for (var key in this.queriesToGlobalStateMap) {
	      initial[key] = null;
	    }
	    var newQuery = (0, _filterSort.parseQuery)(getQuery, initial);
	
	    var changed = false;
	    var newState = {};
	    for (var _key in this.queriesToGlobalStateMap) {
	      var globalKey = this.queriesToGlobalStateMap[_key];
	
	      if (_globalState2.default.state[globalKey] !== newQuery[_key]) {
	        changed = true;
	      }
	
	      newState[globalKey] = newQuery[_key];
	    }
	
	    if (changed) {
	      _globalState2.default.setState(newState);
	    }
	  };
	
	  FilterSort.prototype.renderContent = function renderContent() {
	    return null;
	  };
	
	  FilterSort.prototype.render = function render() {
	    var _props$inHeader = this.props.inHeader,
	        inHeader = _props$inHeader === undefined ? true : _props$inHeader;
	
	
	    if (!inHeader) {
	      return _react2.default.createElement(
	        'div',
	        { className: _headerFilterSortModule2.default.notInHeader },
	        this.renderContent()
	      );
	    } else {
	      return this.renderContent();
	    }
	  };
	
	  return FilterSort;
	}(_react2.default.PureComponent);
	
	exports.default = FilterSort;
	exports.parseQuery = _filterSort.parseQuery;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouter = __webpack_require__(29);
	
	var _logo = __webpack_require__(158);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _menuButton = __webpack_require__(236);
	
	var _menuButton2 = _interopRequireDefault(_menuButton);
	
	var _menu = __webpack_require__(237);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _articleFilterSort = __webpack_require__(112);
	
	var _articleFilterSort2 = _interopRequireDefault(_articleFilterSort);
	
	var _portfolioFilter = __webpack_require__(113);
	
	var _portfolioFilter2 = _interopRequireDefault(_portfolioFilter);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _headerModule = __webpack_require__(192);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var header = _headerModule2.default.header,
	    container = _headerModule2.default.container,
	    headerFilters = _headerModule2.default.headerFilters,
	    headerLogo = _headerModule2.default.headerLogo,
	    headerMenu = _headerModule2.default.headerMenu,
	    headerMenuPos = _headerModule2.default.headerMenuPos,
	    fixed = _headerModule2.default.fixed,
	    fixedHiding = _headerModule2.default.fixedHiding,
	    absolute = _headerModule2.default.absolute,
	    absoluteHiding = _headerModule2.default.absoluteHiding,
	    headerLogoFaded = _headerModule2.default.headerLogoFaded;
	
	
	var AnimationDuration = 300;
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	
	    _this.state = {
	      logoWidth: 0,
	      logoHeight: 0,
	      logoLeft: 0,
	      logoOffset: 0,
	      logoHiding: null,
	
	      menuButtonTop: 20,
	      menuButtonWidth: 0,
	      menuButtonHeight: 0,
	      menuButtonLeft: 0,
	      menuButtonHiding: null,
	
	      headerBottom: 0,
	      headerHeight: 0
	    };
	
	    _this.isWatchingResize = false;
	    _this.watchingResizeTimeout = null;
	    return _this;
	  }
	
	  Header.prototype.onResize = function onResize() {
	    var _this2 = this;
	
	    var logoRect = this.headerLogo.getBoundingClientRect();
	    var menuButtonRect = this.headerMenuButton.getBoundingClientRect();
	
	    this.setState(function (state) {
	      return _extends({}, state, {
	        logoWidth: logoRect.width,
	        logoHeight: menuButtonRect.height,
	        logoLeft: logoRect.left,
	        logoOffset: logoRect.top - menuButtonRect.top,
	        menuButtonWidth: menuButtonRect.width,
	        menuButtonHeight: menuButtonRect.height,
	        menuButtonLeft: menuButtonRect.left,
	        headerBottom: menuButtonRect.bottom,
	        headerHeight: _this2.headerContainer.offsetHeight
	      });
	    });
	    _globalState2.default.setState({ menuRightFromLeft: menuButtonRect.right });
	  };
	
	  Header.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    if (!this.isWatchingResize && (nextProps.fixedMenu || nextProps.fixedLogo)) {
	      window.addEventListener('resize', this.onResize);
	      this.onResize();
	      this.isWatchingResize = true;
	
	      if (this.watchingResizeTimeout) {
	        clearTimeout(this.watchingResizeTimeout);
	        this.watchingResizeTimeout = null;
	      }
	    }
	
	    if (this.props.fixedMenu !== nextProps.fixedMenu && !nextProps.fixedMenu) {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          menuButtonHiding: _this3.state.headerBottom < 0 ? 'fixed' : 'absolute'
	        });
	      });
	
	      setTimeout(function () {
	        _this3.setState(function (state) {
	          return _extends({}, state, { menuButtonHiding: false });
	        });
	      }, AnimationDuration);
	    }
	
	    if (this.props.fixedLogo !== nextProps.fixedLogo && !nextProps.fixedLogo) {
	      this.setState(function (state) {
	        return _extends({}, state, {
	          logoHiding: _this3.state.headerBottom < 0 ? 'fixed' : 'absolute'
	        });
	      });
	
	      setTimeout(function () {
	        _this3.setState(function (state) {
	          return _extends({}, state, { logoHiding: false });
	        });
	      }, AnimationDuration);
	    }
	  };
	
	  Header.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    var _this4 = this;
	
	    if (this.isWatchingResize && !nextProps.fixedMenu && !nextProps.fixedLogo && !(nextState.menuButtonHiding === 'fixed') && !(nextState.logoHiding === 'fixed')) {
	      this.watchingResizeTimeout = setTimeout(function () {
	        window.removeEventListener('resize', _this4.onResize);
	        _this4.isWatchingResize = false;
	      }, AnimationDuration); // a little more after css transition end
	    }
	  };
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    if (document.readyState === 'complete') {
	      this.onResize();
	    } else {
	      window.addEventListener('load', this.onResize);
	    }
	  };
	
	  Header.prototype.render = function render() {
	    var _this5 = this;
	
	    var _props = this.props,
	        whiteLogo = _props.whiteLogo,
	        menuOpen = _props.menuOpen,
	        menuHover = _props.menuHover,
	        fixedMenu = _props.fixedMenu,
	        fixedLogo = _props.fixedLogo,
	        headerWidget = _props.headerWidget,
	        language = _props.language,
	        inMenuScrolled = _props.inMenuScrolled,
	        windowWide = _props.windowWide;
	    var _state = this.state,
	        logoHiding = _state.logoHiding,
	        menuButtonHiding = _state.menuButtonHiding;
	
	
	    var menuButtonStyle = fixedMenu || menuButtonHiding === 'fixed' ? {
	      height: this.state.menuButtonHeight,
	      left: this.state.menuButtonLeft,
	      width: this.state.menuButtonWidth,
	      transform: 'translateY(' + (menuButtonHiding === 'fixed' ? -this.state.headerHeight : Math.max(0, this.state.headerBottom) - this.state.headerHeight) + 'px)'
	    } : {
	      transform: 'translateY(' + (menuButtonHiding === 'absolute' ? -this.state.headerBottom + this.state.headerHeight : 0) + 'px)'
	    };
	
	    var logoStyle = fixedLogo || logoHiding === 'fixed' ? {
	      height: this.state.logoHeight,
	      left: this.state.logoLeft,
	      top: this.state.logoOffset + 20,
	      width: this.state.logoWidth,
	      transform: 'translateY(' + (logoHiding === 'fixed' ? -this.state.headerHeight : Math.max(0, this.state.headerBottom) - this.state.headerHeight) + 'px)'
	    } : {
	      transform: 'translateY(' + (logoHiding === 'absolute' ? -this.state.headerBottom + +this.state.headerHeight : 0) + 'px)'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: header },
	      _react2.default.createElement(_menu2.default, { open: menuOpen, hover: menuHover }),
	      _react2.default.createElement(
	        'div',
	        { className: container, ref: function ref(_ref3) {
	            return _this5.headerContainer = _ref3;
	          } },
	        _react2.default.createElement(
	          'div',
	          {
	            className: menuOpen && inMenuScrolled ? headerLogoFaded : headerLogo,
	            ref: function ref(_ref) {
	              return _this5.headerLogo = _ref;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: logoHiding === 'fixed' ? fixedHiding : fixedLogo ? fixed : logoHiding === 'absolute' ? absoluteHiding : absolute,
	              style: logoStyle
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: (0, _linkBuilder2.default)({
	                  lang: language,
	                  slug: '',
	                  type: 'page'
	                })
	              },
	              _react2.default.createElement(_logo2.default, { expanded: menuOpen, light: menuOpen })
	            )
	          )
	        ),
	        windowWide && _react2.default.createElement(
	          'div',
	          { className: headerFilters },
	          headerWidget === 'articleFilterSort' && _react2.default.createElement(_articleFilterSort2.default, null),
	          headerWidget === 'portfolioFilter' && _react2.default.createElement(_portfolioFilter2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: headerMenu,
	            ref: function ref(_ref2) {
	              return _this5.headerMenuButton = _ref2;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: menuButtonHiding === 'fixed' ? fixedHiding : fixedMenu ? fixed : menuButtonHiding === 'absolute' ? absoluteHiding : absolute,
	              style: menuButtonStyle
	            },
	            _react2.default.createElement(_menuButton2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _stateProvider2.default)(Header, function (state) {
	  return {
	    menuOpen: state.menuOpen,
	    menuHover: state.menuHover,
	    fixedMenu: state.fixedMenu,
	    inMenuScrolled: state.inMenuScrolled,
	    fixedLogo: state.fixedLogo,
	    whiteLogo: state.whiteLogo,
	    headerWidget: state.headerWidget,
	    language: state.language,
	    windowWide: state.windowWidth > 1200
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _colors = __webpack_require__(41);
	
	var _menuButtonModule = __webpack_require__(396);
	
	var _menuButtonModule2 = _interopRequireDefault(_menuButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var menuHamburgerButton = _menuButtonModule2.default.menuHamburgerButton,
	    menuCloseButton = _menuButtonModule2.default.menuCloseButton,
	    menuLoadingButton = _menuButtonModule2.default.menuLoadingButton,
	    menuAccentLine = _menuButtonModule2.default.menuAccentLine,
	    menuButtonLines = _menuButtonModule2.default.menuButtonLines;
	
	
	var backgroundColor = _colors.white;
	var shapeColor = _colors.darkGray;
	
	var MenuButton = function (_React$PureComponent) {
	  _inherits(MenuButton, _React$PureComponent);
	
	  function MenuButton(props) {
	    _classCallCheck(this, MenuButton);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      hover: false
	    };
	
	    _this.lastTop = 0;
	
	    _this.toggleOpen = _this.toggleOpen.bind(_this);
	    // this.onKeyPress = this.onKeyPress.bind(this);
	    _this.onScroll = _this.onScroll.bind(_this);
	    return _this;
	  }
	
	  MenuButton.prototype.componentDidMount = function componentDidMount() {
	    // window.addEventListener('keypress', this.onKeyPress);
	    window.addEventListener('scroll', this.onScroll);
	  };
	
	  // componentWillUnmount() {
	  //   window.removeEventListener('keypress', this.onKeyPress);
	  // }
	
	  // onKeyPress(e) {
	  //   if (e.code === 'KeyM') {
	  //     this.toggleOpen();
	  //   } else if (e.code === 'KeyL') {
	  //     globalState.setState({ loading: !globalState.state.loading });
	  //   }
	  // }
	
	  MenuButton.prototype.onScroll = function onScroll(e) {
	    if (!this.props.menuOpen) {
	      var currentTop = document.documentElement.scrollTop + document.body.scrollTop;
	      var delta = currentTop - this.lastTop;
	      if (delta !== 0) {
	        _globalState2.default.setState({
	          scrolledUp: delta <= 0 && currentTop > 500
	        });
	      }
	      this.lastTop = currentTop;
	    }
	  };
	
	  MenuButton.prototype.toggleOpen = function toggleOpen() {
	    _globalState2.default.setState({ menuOpen: !_globalState2.default.state.menuOpen });
	  };
	
	  MenuButton.prototype.render = function render() {
	    var _props = this.props,
	        menuOpen = _props.menuOpen,
	        loading = _props.loading,
	        menuHover = _props.menuHover;
	    // const { hover } = this.state;
	
	    /* <div
	      onClick={() => {
	        globalState.setState({ menuOpen: false, loading: false });
	      }}
	      style={{
	        zIndex: 99999,
	        position: 'fixed',
	        right: 150,
	        top: 0,
	        color: 'white',
	        background: 'black',
	        cursor: 'pointer',
	      }}
	    >
	      menu
	    </div>
	    <div
	      onClick={() => {
	        globalState.setState({ menuOpen: true, loading: false });
	      }}
	      style={{
	        zIndex: 99999,
	        position: 'fixed',
	        right: 150,
	        top: 50,
	        color: 'white',
	        background: 'black',
	        cursor: 'pointer',
	      }}
	    >
	      close
	    </div>
	    <div
	      onClick={() => {
	        globalState.setState({ loading: true });
	      }}
	      style={{
	        zIndex: 99999,
	        position: 'fixed',
	        right: 150,
	        top: 100,
	        color: 'white',
	        background: 'black',
	        cursor: 'pointer',
	      }}
	    >
	      loading
	    </div> */
	
	    var accentLineProps = {};
	    if (!loading && menuOpen) {
	      accentLineProps['transform'] = 'translate(0,35)';
	    }
	    return (
	      // <div className={menuWrapper}>
	
	      _react2.default.createElement(
	        'div',
	        {
	          onClick: this.toggleOpen,
	          onMouseEnter: function onMouseEnter() {
	            // globalState.setState({ menuHover: true });
	            // this.setState({ ...this.state, hover: true });
	          },
	          onMouseLeave: function onMouseLeave() {
	            // globalState.setState({ menuHover: false });
	            // this.setState({ ...this.state, hover: false });
	          },
	          className: loading ? menuLoadingButton : menuOpen ? menuCloseButton : menuHamburgerButton
	        },
	        _react2.default.createElement(
	          'svg',
	          { viewBox: '0 0 122.35162 95.943878', width: '98', height: '79' },
	          _react2.default.createElement('path', {
	            fill: backgroundColor,
	            d: 'm 26.40825,5e-4 0,69.53625 -26.40875,26.4075 122.3525,0 0,-95.94375 -95.94375,0 z'
	          }),
	          _react2.default.createElement('path', _extends({
	            className: menuAccentLine,
	            fill: shapeColor,
	            d: 'm 49.269531,63.287109 0,6.25 16.169922,0 8.941406,8.949219 8.939453,-8.949219 16.169922,0 0,-6.25 -18.759765,0 -6.34961,6.355469 -6.351562,-6.355469 -18.759766,0 z'
	          }, accentLineProps))
	        ),
	        _react2.default.createElement('div', { className: menuButtonLines })
	      )
	      // </div>
	
	    );
	  };
	
	  return MenuButton;
	}(_react2.default.PureComponent);
	
	exports.default = (0, _stateProvider2.default)(MenuButton, function (state) {
	  return {
	    menuOpen: state.menuOpen,
	    loading: state.loading
	    // scrolledUp: state.scrolledUp,
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(29);
	
	var _filterSort = __webpack_require__(40);
	
	var _filterSort2 = _interopRequireDefault(_filterSort);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _headerFilterSortModule = __webpack_require__(22);
	
	var _headerFilterSortModule2 = _interopRequireDefault(_headerFilterSortModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _headerFilterSortModule2.default.container,
	    list = _headerFilterSortModule2.default.list;
	
	var PortfolioFilter = function (_FilterSort) {
	  _inherits(PortfolioFilter, _FilterSort);
	
	  function PortfolioFilter() {
	    _classCallCheck(this, PortfolioFilter);
	
	    return _possibleConstructorReturn(this, _FilterSort.apply(this, arguments));
	  }
	
	  PortfolioFilter.prototype.queriesToGlobalState = function queriesToGlobalState() {
	    return {
	      filter: 'portfolioFilter'
	    };
	  };
	
	  PortfolioFilter.prototype.renderContent = function renderContent() {
	    var _this2 = this;
	
	    var _parseQuery = (0, _filterSort.parseQuery)(this.props.location.search, {
	      filter: null
	    }),
	        filter = _parseQuery.filter;
	
	    var filterOptions = [{
	      label: (0, _stringTranslation.translate)('all'),
	      value: null
	    }].concat(_globalState2.default.state.portfolioCategories.filter(function (category) {
	      return category.lang === _this2.props.language;
	    }).map(function (category) {
	      return {
	        label: category.label,
	        value: category.slug
	      };
	    }));
	
	    return _react2.default.createElement(
	      'div',
	      { className: container },
	      _react2.default.createElement(
	        'ul',
	        { className: list },
	        this.renderOptions(filterOptions, filter, 'portfolioFilter', 'filter')
	      )
	    );
	  };
	
	  return PortfolioFilter;
	}(_filterSort2.default);
	
	exports.default = (0, _stateProvider2.default)((0, _reactRouter.withRouter)(PortfolioFilter), function (state) {
	  return {
	    filter: state.portfolioFilter,
	    language: state.language
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(41);
	
	var _logoModule = __webpack_require__(394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_React$PureComponent) {
	  _inherits(Logo, _React$PureComponent);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Logo.prototype.render = function render() {
	    var _props = this.props,
	        light = _props.light,
	        width = _props.width,
	        expanded = _props.expanded;
	
	
	    var height = 57 * width / 295;
	
	    var sygnetColor = light ? _colors.lightGray : _colors.purple;
	    var letterColor = _colors.lightGray; //light ? lightGray : darkGray
	
	    var sygnetStyle = {
	      fill: sygnetColor
	    };
	
	    var sygnetProps = {};
	
	    if (!expanded) {
	      sygnetStyle['transform'] = 'translateX(-334px)';
	      sygnetProps['transform'] = 'translate(-334, 0)';
	    }
	
	    return _react2.default.createElement(
	      'svg',
	      {
	        xmlns: 'http://www.w3.org/2000/svg',
	        viewBox: '0 0 368.13 70.864876',
	        width: width,
	        height: height,
	        className: _logoModule.logo
	      },
	      _react2.default.createElement('path', {
	        d: 'M 295.10547 40.71875 C 295.10547 48.255 295.10547 55.793828 295.10547 63.330078 C 295.10647 64.441328 294.17289 65.375 293.05664 65.375 C 290.35164 65.375 287.64469 65.383516 284.92969 65.384766 C 283.81844 65.383566 282.88281 64.452188 282.88281 63.335938 L 282.88281 40.753906 L 277.24023 40.75 C 277.24023 48.28 277.23633 55.809687 277.23633 63.335938 C 277.24033 67.472187 280.62633 70.864531 284.76758 70.863281 C 287.52883 70.863281 290.28953 70.865234 293.05078 70.865234 C 294.90703 70.864034 296.61148 70.184844 297.92773 69.058594 C 299.24273 70.182344 300.94523 70.865234 302.80273 70.865234 C 305.56523 70.864034 308.32664 70.865234 311.08789 70.865234 C 315.22789 70.864034 318.61328 67.477187 318.61328 63.335938 L 318.61328 40.753906 L 312.97266 40.75 C 312.97266 48.28 312.96875 55.809687 312.96875 63.335938 C 312.97275 64.449688 312.03633 65.384766 310.92383 65.384766 C 308.21883 65.378466 305.5118 65.375 302.81055 65.375 C 301.6993 65.375 300.76172 64.443828 300.76172 63.330078 C 300.76372 55.785078 300.74805 48.27 300.74805 40.71875 L 295.10547 40.71875 z M 0.00390625 40.738281 C 0.00390625 50.773281 0.001953125 60.811406 0.001953125 70.847656 L 22.583984 70.845703 C 26.723984 70.845703 30.111328 67.456562 30.111328 63.320312 L 30.111328 60.667969 C 30.111328 58.812969 29.427734 57.107969 28.302734 55.792969 C 29.430234 54.476719 30.111328 52.772266 30.111328 50.916016 L 30.111328 48.263672 C 30.111328 44.122422 26.721484 40.738281 22.583984 40.738281 L 0.00390625 40.738281 z M 35.796875 40.738281 C 35.796875 50.773281 35.792969 60.811406 35.792969 70.847656 L 41.453125 70.845703 L 41.453125 61.138672 L 50.851562 61.138672 L 60.558594 70.845703 L 67.806641 70.845703 L 58.097656 61.138672 L 58.378906 61.138672 C 62.512656 61.138672 65.900391 57.757734 65.900391 53.615234 C 65.904191 52.683984 65.900391 49.198828 65.900391 48.267578 C 65.904189 44.123896 62.514616 40.740433 58.378906 40.738281 L 35.796875 40.738281 z M 73.488281 40.738281 L 73.488281 46.230469 L 93.060547 46.216797 C 94.175547 46.216797 95.109375 47.151328 95.109375 48.267578 C 95.111875 49.813828 95.09375 51.34375 95.09375 52.90625 L 78.171875 52.902344 C 74.031875 52.902344 70.642578 56.293594 70.642578 60.433594 C 70.645078 61.363594 70.642578 62.386562 70.642578 63.320312 C 70.645078 67.456563 74.030625 70.847656 78.171875 70.847656 L 95.335938 70.845703 L 100.75391 70.845703 L 100.75391 65.373047 C 100.75391 59.670547 100.75195 53.971328 100.75195 48.267578 C 100.75295 44.122578 97.364766 40.738281 93.228516 40.738281 L 73.488281 40.738281 z M 106.44922 40.738281 L 106.44922 41.070312 L 106.44922 70.845703 L 112.10938 70.845703 L 112.10938 46.216797 L 128.88867 46.216797 C 130.00367 46.216797 130.93555 47.151328 130.93555 48.267578 L 130.90039 70.845703 L 136.55859 70.845703 C 136.55859 63.319453 136.55469 55.793828 136.55469 48.267578 C 136.55669 44.122578 133.16875 40.738281 129.03125 40.738281 L 106.44922 40.738281 z M 142.62305 40.738281 C 142.62305 40.738281 142.62305 68.626406 142.62305 70.847656 L 165.20703 70.845703 C 169.34578 70.845703 172.73242 67.456562 172.73242 63.320312 L 172.73242 48.263672 C 172.73242 44.122422 169.34578 40.738281 165.20703 40.738281 L 142.62305 40.738281 z M 215.11719 40.75 C 215.11719 48.28 215.11523 55.809687 215.11523 63.335938 C 215.11723 67.471531 218.50222 70.863455 222.64258 70.863281 L 222.64453 70.863281 L 239.82617 70.863281 L 239.82617 65.369141 L 222.81055 65.384766 C 221.6918 65.384766 220.75977 64.452188 220.75977 63.335938 L 220.75977 40.753906 L 215.11719 40.75 z M 265.35156 40.75 C 260.33031 40.75 255.31297 40.753906 250.29297 40.753906 C 246.15547 40.750206 242.76758 44.145 242.76758 48.28125 L 242.76953 63.333984 C 242.76953 67.473984 246.15547 70.865234 250.29297 70.865234 C 255.31297 70.864034 260.33016 70.865234 265.34766 70.865234 C 269.49266 70.864034 272.87695 67.477891 272.87695 63.337891 L 272.87695 48.28125 C 272.87695 44.1425 269.48891 40.753906 265.34766 40.753906 L 265.35156 40.75 z M 209.24023 40.751953 L 186.6582 40.755859 C 182.51695 40.755859 179.13086 44.1425 179.13086 48.28125 L 179.13086 63.337891 C 179.13086 67.477891 182.5182 70.863281 186.6582 70.863281 L 209.23828 70.865234 C 209.23828 64.902734 209.24023 58.941719 209.24023 52.980469 L 194.01367 52.980469 L 194.01367 58.636719 L 203.58594 58.636719 L 203.58594 65.382812 L 186.6582 65.386719 C 185.54195 65.386719 184.61328 64.451484 184.61328 63.333984 L 184.60938 48.28125 C 184.60937 47.1675 185.54195 46.236328 186.6582 46.236328 L 209.24023 46.236328 L 209.24023 40.751953 z M 5.4824219 46.216797 L 22.583984 46.216797 C 23.695234 46.216797 24.628906 47.151328 24.628906 48.267578 L 24.632812 50.914062 C 24.632812 52.031562 23.695078 52.964844 22.580078 52.964844 L 5.4824219 52.960938 L 5.4824219 46.216797 z M 58.378906 46.216797 C 59.495156 46.216797 60.421875 47.151328 60.421875 48.267578 C 60.424375 49.198828 60.421328 52.683984 60.423828 53.615234 C 60.423828 54.730234 59.49125 55.664062 58.375 55.664062 L 41.275391 55.660156 C 41.275391 53.366406 41.271484 48.51125 41.271484 46.21875 L 58.378906 46.216797 z M 148.28516 46.216797 L 165.20703 46.216797 C 166.32328 46.216797 167.25195 47.151328 167.25195 48.267578 L 167.25195 63.318359 C 167.25195 64.434609 166.31953 65.369141 165.20703 65.369141 L 148.28516 65.365234 C 148.28516 58.985234 148.28316 52.601797 148.28516 46.216797 z M 250.29297 46.236328 L 265.34766 46.236328 L 265.35156 46.236328 C 266.46781 46.236328 267.39648 47.1675 267.39648 48.28125 L 267.39844 63.333984 C 267.39844 64.451484 266.46391 65.386719 265.34766 65.386719 C 260.33016 65.385519 255.31297 65.386719 250.29297 65.386719 C 249.17922 65.385519 248.24219 64.452891 248.24219 63.337891 L 248.24805 48.28125 C 248.24805 47.165 249.17797 46.236328 250.29297 46.236328 z M 95.273438 58.382812 L 95.273438 65.369141 L 78.171875 65.365234 C 77.060625 65.365234 76.123047 64.434063 76.123047 63.320312 C 76.124247 62.386562 76.1238 61.363594 76.125 60.433594 C 76.125 59.312344 77.056875 58.384766 78.171875 58.384766 L 95.273438 58.382812 z M 5.4824219 58.623047 L 22.583984 58.623047 C 23.695234 58.623047 24.628906 59.552969 24.628906 60.667969 L 24.632812 63.318359 C 24.632812 64.434609 23.695078 65.369141 22.580078 65.369141 L 5.4824219 65.365234 L 5.4824219 58.623047 z ',
	        style: {
	          fill: letterColor,
	          opacity: expanded ? 1 : 0
	        }
	      }),
	      _react2.default.createElement('path', _extends({
	        d: 'm 338.02537,25.96325 -4.145,4.14625 30.10375,0 4.14625,-4.14625 0,-6.7675 -4.14625,-4.14125 4.14625,-4.1425 0,-6.76625 -4.14625,-4.14625 -30.10375,0 4.145,4.14625 c 0,7.2725 -0.004,14.5475 -0.004,21.82125 l 0.004,-0.0038 z',
	        style: sygnetStyle
	      }, sygnetProps))
	    );
	  };
	
	  return Logo;
	}(_react2.default.PureComponent);
	
	Logo.propTypes = {
	  light: _propTypes2.default.bool.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  expanded: _propTypes2.default.bool.isRequired
	};
	
	Logo.defaultProps = {
	  width: 295,
	  expanded: true
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _headerSpacer = __webpack_require__(20);
	
	var _headerSpacer2 = _interopRequireDefault(_headerSpacer);
	
	var _searchInput = __webpack_require__(238);
	
	var _searchInput2 = _interopRequireDefault(_searchInput);
	
	var _stateProvider = __webpack_require__(16);
	
	var _stateProvider2 = _interopRequireDefault(_stateProvider);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _stringTranslation = __webpack_require__(13);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _colors = __webpack_require__(41);
	
	var _menuModule = __webpack_require__(395);
	
	var _menuModule2 = _interopRequireDefault(_menuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var container = _menuModule2.default.container,
	    menuHidden = _menuModule2.default.menuHidden,
	    menuHover = _menuModule2.default.menuHover,
	    inner = _menuModule2.default.inner,
	    menuOpen = _menuModule2.default.menuOpen,
	    backgroundLeft = _menuModule2.default.backgroundLeft,
	    backgroundRight = _menuModule2.default.backgroundRight,
	    menuList = _menuModule2.default.menuList,
	    menuItem = _menuModule2.default.menuItem,
	    menuLink = _menuModule2.default.menuLink,
	    menuItemWrapper = _menuModule2.default.menuItemWrapper;
	
	
	var accentColorRGB = (0, _colors.rgb2hsl)((0, _colors.h2r)(_colors.accentColor));
	var blackColorRGB = [0.9221183800623053, 0, 0];
	
	var MenuItemArrow = function (_React$PureComponent) {
	  _inherits(MenuItemArrow, _React$PureComponent);
	
	  function MenuItemArrow() {
	    _classCallCheck(this, MenuItemArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  MenuItemArrow.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        open = _props.open,
	        _onClick = _props.onClick;
	
	
	    var classNames = [open ? _menuModule2.default.submenuArrowExpanded : _menuModule2.default.submenuArrow];
	
	    if (className) {
	      classNames.push(className);
	    }
	
	    return _react2.default.createElement(
	      'span',
	      {
	        onClick: function onClick() {
	          if (_onClick) {
	            _onClick();
	          }
	        },
	        className: classNames.join(' '),
	        title: open ? 'Schowaj podmenu' : 'Rozwiń podmenu'
	      },
	      _react2.default.createElement('span', { className: _menuModule2.default.submenuArrowExpand }),
	      _react2.default.createElement('span', { className: _menuModule2.default.submenuArrowCollapse })
	    );
	  };
	
	  return MenuItemArrow;
	}(_react2.default.PureComponent);
	
	var MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    var _this2 = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this2.onClick = _this2.onClick.bind(_this2);
	    _this2.state = {
	      open: false
	    };
	    return _this2;
	  }
	
	  MenuItem.prototype.onClick = function onClick() {
	    this.setState(function (state) {
	      return _extends({}, state, { open: !state.open });
	    });
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        to = _props2.to,
	        label = _props2.label,
	        submenu = _props2.submenu;
	    var open = this.state.open;
	
	
	    return _react2.default.createElement(
	      'li',
	      { className: menuItem, key: label },
	      _react2.default.createElement(
	        'div',
	        { className: menuItemWrapper },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: menuLink, to: to },
	          label
	        ),
	        submenu && _react2.default.createElement(MenuItemArrow, {
	          onClick: this.onClick,
	          className: _menuModule2.default.itemSubmenuArrow,
	          open: open
	        })
	      ),
	      submenu && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            className: open ? _menuModule2.default.itemSubmenu : _menuModule2.default.itemSubmenuHidden
	          },
	          submenu.map(function (item, index) {
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                key: index,
	                className: open ? _menuModule2.default.itemSubmenuItem : _menuModule2.default.itemSubmenuItemHidden,
	                to: item.to
	              },
	              item.label
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	var Menu = function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  function Menu(props) {
	    _classCallCheck(this, Menu);
	
	    var _this3 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
	    _this3.lastScrollTop = null;
	    _this3.lastScrollBody = false;
	
	    _this3.state = {
	      backgroundProgress: 0,
	      inMenuScrolled: 0
	    };
	
	    _this3.setRef = _this3.setRef.bind(_this3);
	    _this3.onMenuScroll = _this3.onMenuScroll.bind(_this3);
	
	    _this3.handleMouseMove = _this3.handleMouseMove.bind(_this3);
	
	    //this.buildRoutes(props.language)
	    _this3.ref = null;
	    return _this3;
	  }
	  /*
	  buildRoutes(lang) {
	    this.routes = [
	      {
	        to: buildLink({
	          slug: 'portfolio',
	          type: 'static',
	          lang,
	        }),
	        label: translate('portfolio'),
	      },
	      {
	        to: buildLink({
	          slug: 'post',
	          type: 'static',
	          lang,
	        }),
	        label: translate('articles'),
	      },
	      {
	        to: buildLink({
	          slug: 'offer',
	          type: 'static',
	          lang,
	        }),
	        label: translate('offer'),
	        submenu: [
	          {
	            to: buildLink({
	              slug: 'analisys',
	              type: 'static',
	              lang,
	            }),
	            label: translate('analisys'),
	          },
	          {
	            to: buildLink({
	              slug: 'strategy',
	              type: 'static',
	              lang,
	            }),
	            label: translate('strategy'),
	          },
	          {
	            to: buildLink({
	              slug: 'identification',
	              type: 'static',
	              lang,
	            }),
	            label: translate('identification'),
	          },
	        ],
	      },
	      {
	        to: buildLink({
	          slug: lang === 'en' ? 'team' : 'zespol',
	          type: 'page',
	          lang,
	        }),
	        label: translate('aboutus'),
	      },
	      {
	        to: buildLink({
	          slug: lang === 'en' ? 'contact' : 'kontakt',
	          type: 'page',
	          lang,
	        }),
	        label: translate('contact'),
	      },
	    ]
	  }
	  */
	
	
	  Menu.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.open !== nextProps.open) {
	      if (nextProps.open) {
	        if (document.documentElement.scrollTop !== 0) {
	          this.lastScrollTop = document.documentElement.scrollTop;
	          this.lastScrollBody = false;
	        } else {
	          this.lastScrollTop = document.body.scrollTop;
	          this.lastScrollBody = true;
	        }
	
	        document.body.style.top = '-' + this.lastScrollTop + 'px';
	
	        document.body.classList.toggle('menu-open', true);
	      } else {
	        document.body.classList.toggle('menu-open', false);
	
	        if (this.lastScrollBody) {
	          document.body.scrollTop = this.lastScrollTop;
	        } else {
	          document.documentElement.scrollTop = this.lastScrollTop;
	        }
	
	        this.lastScrollTop = null;
	      }
	    }
	
	    // if (this.props.language !== nextProps.language) {
	    //   this.buildRoutes(nextProps.language)
	    // }
	  };
	
	  Menu.prototype.handleMouseMove = function handleMouseMove(e) {
	    var _this4 = this;
	
	    var progress = e.clientY / window.innerHeight;
	    this.setState(function (state) {
	      return _extends({}, _this4.state, {
	        backgroundProgress: progress,
	        backgroundColor: (0, _colors.r2h)((0, _colors.interpolateHSL)(accentColorRGB, blackColorRGB, progress))
	      });
	    });
	  };
	
	  Menu.prototype.onMenuScroll = function onMenuScroll() {
	    var inMenuScrolled = this.ref.scrollTop > 30;
	    if (inMenuScrolled !== _globalState2.default.state.inMenuScrolled) {
	      _globalState2.default.setState({ inMenuScrolled: inMenuScrolled });
	    }
	  };
	
	  Menu.prototype.setRef = function setRef(ref) {
	    if (this.ref !== ref && this.ref) {
	      this.ref.removeEventListener('scroll', this.onMenuScroll);
	    }
	
	    this.ref = ref;
	
	    if (ref) {
	      ref.addEventListener('scroll', this.onMenuScroll);
	    }
	  };
	
	  Menu.prototype.render = function render() {
	    var _props3 = this.props,
	        open = _props3.open,
	        hover = _props3.hover,
	        translations = _props3.translations,
	        language = _props3.language,
	        routes = _props3.routes,
	        languages = _props3.languages;
	    var inMenuScrolled = this.state.inMenuScrolled;
	
	
	    var backgroundStyle = {
	      backgroundColor: this.state.backgroundColor
	    };
	
	    return _react2.default.createElement(
	      'div',
	      {
	        ref: this.setRef,
	        onMouseMove: this.handleMouseMove,
	        className: open ? menuOpen : hover ? menuHover : menuHidden
	      },
	      _react2.default.createElement('div', { className: backgroundLeft, style: backgroundStyle }),
	      _react2.default.createElement('div', { className: backgroundRight, style: backgroundStyle }),
	      _react2.default.createElement(_headerSpacer2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: inner },
	        _react2.default.createElement(
	          'div',
	          { className: container },
	          _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: menuList },
	              routes.map(function (props, index) {
	                return _react2.default.createElement(MenuItem, _extends({ key: index }, props));
	              })
	            )
	          ),
	          languages.length > 0 && _react2.default.createElement(
	            'div',
	            { className: _menuModule2.default.languages },
	            languages.map(function (lang) {
	              if (lang in translations) {
	                return _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    key: lang,
	                    to: translations[lang],
	                    className: _menuModule2.default.languageItem
	                  },
	                  lang
	                );
	              } else if (lang !== language) {
	                return _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    key: lang,
	                    to: (0, _linkBuilder2.default)({
	                      lang: lang,
	                      slug: '',
	                      type: 'page'
	                    }),
	                    className: _menuModule2.default.languageItem
	                  },
	                  lang
	                );
	              }
	              return _react2.default.createElement(
	                'div',
	                { key: lang, className: _menuModule2.default.languageItem },
	                lang
	              );
	            })
	          ),
	          _react2.default.createElement(_searchInput2.default, { open: open })
	        )
	      )
	    );
	  };
	
	  return Menu;
	}(_react2.default.Component);
	
	exports.default = (0, _stateProvider2.default)(Menu, function (state) {
	  return {
	    translations: state.translations,
	    language: state.language,
	    languages: state.languages,
	    routes: state.menu[state.language]
	  };
	});
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _searchInputModule = __webpack_require__(402);
	
	var _searchInputModule2 = _interopRequireDefault(_searchInputModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchIcon = function SearchIcon(_ref) {
	  var onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'svg',
	    {
	      onClick: onClick,
	      className: _searchInputModule2.default.searchIcon,
	      viewBox: '0 0 91.685753 91.641876'
	    },
	    _react2.default.createElement('path', { d: 'M 17.235,5e-4 0,17.23425 l 0,24.3725 17.235,17.235 24.3725,0 4.99625,-4.99625 12.26125,12.26125 0,2.26875 23.26625,23.26625 2.2775,0 7.27625,-7.2775 0,-2.2775 -23.265,-23.26625 -2.27,0 -12.26125,-12.2625 4.9525,-4.95125 0,-24.3725 L 41.6075,5e-4 17.235,5e-4 Z m -6.76375,37.26875 0,-15.6975 11.10125,-11.10125 15.69625,0 11.10125,11.10125 0,15.6975 -11.10125,11.1 -15.69625,0 -11.10125,-11.1 z m 12.08,-22.77125 -7.9175,7.91875 0,7.00375 3.665,0 0,-5.48625 5.77,-5.77125 5.3525,0 0,-3.665 -6.87,0 z' })
	  );
	};
	
	var SearchInput = function (_React$PureComponent) {
	  _inherits(SearchInput, _React$PureComponent);
	
	  function SearchInput(props) {
	    _classCallCheck(this, SearchInput);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.search = _this.search.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	
	    _this.state = {
	      focus: false,
	      query: ''
	    };
	    return _this;
	  }
	
	  SearchInput.prototype.search = function search() {
	    var searchPath = (0, _linkBuilder2.default)({
	      slug: 'search',
	      type: 'static',
	      lang: _globalState2.default.state.language
	    });
	
	    var path = searchPath + '/' + encodeURIComponent(this.state.query);
	    window.___navigateTo(path);
	  };
	
	  SearchInput.prototype.onFocus = function onFocus() {
	    this.setState(function (state) {
	      return _extends({}, state, { focus: true });
	    });
	  };
	
	  SearchInput.prototype.onBlur = function onBlur() {
	    this.setState(function (state) {
	      return _extends({}, state, { focus: false });
	    });
	  };
	
	  SearchInput.prototype.handleChange = function handleChange(event) {
	    this.setState(_extends({}, this.state, { query: event.target.value }));
	  };
	
	  SearchInput.prototype.handleKeyPress = function handleKeyPress(event) {
	    if (event.charCode === 13) {
	      this.search();
	    }
	  };
	
	  SearchInput.prototype.render = function render() {
	    var open = this.props.open;
	    var _state = this.state,
	        focus = _state.focus,
	        query = _state.query;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: open ? _searchInputModule2.default.wrapperPositionOpen : _searchInputModule2.default.wrapperPosition
	      },
	      _react2.default.createElement(
	        'div',
	        { className: focus ? _searchInputModule2.default.wrapperFocus : _searchInputModule2.default.wrapper },
	        _react2.default.createElement('input', {
	          className: _searchInputModule2.default.input,
	          type: 'text',
	          value: query,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onChange: this.handleChange,
	          onKeyPress: this.handleKeyPress
	        }),
	        _react2.default.createElement(SearchIcon, { onClick: this.search })
	      )
	    );
	  };
	
	  return SearchInput;
	}(_react2.default.PureComponent);
	
	exports.default = SearchInput;
	module.exports = exports['default'];

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof window !== 'undefined') {
	  /*! modernizr 3.5.0 (Custom Build) | MIT *
	  * https://modernizr.com/download/?-objectfit-setclasses !*/
	  !function (e, n, t) {
	    function r(e, n) {
	      return typeof e === n;
	    }
	    function o() {
	      var e, n, t, o, i, s, a;
	      for (var l in C) {
	        if (C.hasOwnProperty(l)) {
	          if (e = [], n = C[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
	            e.push(n.options.aliases[t].toLowerCase());
	          }for (o = r(n.fn, 'function') ? n.fn() : n.fn, i = 0; i < e.length; i++) {
	            s = e[i], a = s.split('.'), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), h.push((o ? '' : 'no-') + a.join('-'));
	          }
	        }
	      }
	    }
	    function i(e) {
	      var n = _.className,
	          t = Modernizr._config.classPrefix || '';
	      if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
	        var r = new RegExp('(^|\\s)' + t + 'no-js(\\s|$)');
	        n = n.replace(r, '$1' + t + 'js$2');
	      }
	      Modernizr._config.enableClasses && (n += ' ' + t + e.join(' ' + t), w ? _.className.baseVal = n : _.className = n);
	    }
	    function s(e) {
	      return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
	        return n + t.toUpperCase();
	      }).replace(/^-/, '');
	    }
	    function a(e, n) {
	      return !!~('' + e).indexOf(n);
	    }
	    function l() {
	      return 'function' != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, 'http://www.w3.org/2000/svg', arguments[0]) : n.createElement.apply(n, arguments);
	    }
	    function f(e, n) {
	      return function () {
	        return e.apply(n, arguments);
	      };
	    }
	    function u(e, n, t) {
	      var o;
	      for (var i in e) {
	        if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, 'function') ? f(o, t || n) : o);
	      }return !1;
	    }
	    function p(e) {
	      return e.replace(/([A-Z])/g, function (e, n) {
	        return '-' + n.toLowerCase();
	      }).replace(/^ms-/, '-ms-');
	    }
	    function c(n, t, r) {
	      var o;
	      if ('getComputedStyle' in e) {
	        o = getComputedStyle.call(e, n, t);
	        var i = e.console;
	        if (null !== o) r && (o = o.getPropertyValue(r));else if (i) {
	          var s = i.error ? 'error' : 'log';
	          i[s].call(i, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
	        }
	      } else o = !t && n.currentStyle && n.currentStyle[r];
	      return o;
	    }
	    function d() {
	      var e = n.body;
	      return e || (e = l(w ? 'svg' : 'body'), e.fake = !0), e;
	    }
	    function m(e, t, r, o) {
	      var i,
	          s,
	          a,
	          f,
	          u = 'modernizr',
	          p = l('div'),
	          c = d();
	      if (parseInt(r, 10)) for (; r--;) {
	        a = l('div'), a.id = o ? o[r] : u + (r + 1), p.appendChild(a);
	      }return i = l('style'), i.type = 'text/css', i.id = 's' + u, (c.fake ? c : p).appendChild(i), c.appendChild(p), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), p.id = u, c.fake && (c.style.background = '', c.style.overflow = 'hidden', f = _.style.overflow, _.style.overflow = 'hidden', _.appendChild(c)), s = t(p, e), c.fake ? (c.parentNode.removeChild(c), _.style.overflow = f, _.offsetHeight) : p.parentNode.removeChild(p), !!s;
	    }
	    function v(n, r) {
	      var o = n.length;
	      if ('CSS' in e && 'supports' in e.CSS) {
	        for (; o--;) {
	          if (e.CSS.supports(p(n[o]), r)) return !0;
	        }return !1;
	      }
	      if ('CSSSupportsRule' in e) {
	        for (var i = []; o--;) {
	          i.push('(' + p(n[o]) + ':' + r + ')');
	        }return i = i.join(' or '), m('@supports (' + i + ') { #modernizr { position: absolute; } }', function (e) {
	          return 'absolute' == c(e, null, 'position');
	        });
	      }
	      return t;
	    }
	    function y(e, n, o, i) {
	      function f() {
	        p && (delete P.style, delete P.modElem);
	      }
	      if (i = r(i, 'undefined') ? !1 : i, !r(o, 'undefined')) {
	        var u = v(e, o);
	        if (!r(u, 'undefined')) return u;
	      }
	      for (var p, c, d, m, y, g = ['modernizr', 'tspan', 'samp']; !P.style && g.length;) {
	        p = !0, P.modElem = l(g.shift()), P.style = P.modElem.style;
	      }for (d = e.length, c = 0; d > c; c++) {
	        if (m = e[c], y = P.style[m], a(m, '-') && (m = s(m)), P.style[m] !== t) {
	          if (i || r(o, 'undefined')) return f(), 'pfx' == n ? m : !0;
	          try {
	            P.style[m] = o;
	          } catch (h) {}
	          if (P.style[m] != y) return f(), 'pfx' == n ? m : !0;
	        }
	      }return f(), !1;
	    }
	    function g(e, n, t, o, i) {
	      var s = e.charAt(0).toUpperCase() + e.slice(1),
	          a = (e + ' ' + b.join(s + ' ') + s).split(' ');
	      return r(n, 'string') || r(n, 'undefined') ? y(a, n, o, i) : (a = (e + ' ' + j.join(s + ' ') + s).split(' '), u(a, n, t));
	    }
	    var h = [],
	        C = [],
	        S = {
	      _version: '3.5.0',
	      _config: {
	        classPrefix: '',
	        enableClasses: !0,
	        enableJSClass: !0,
	        usePrefixes: !0
	      },
	      _q: [],
	      on: function on(e, n) {
	        var t = this;
	        setTimeout(function () {
	          n(t[e]);
	        }, 0);
	      },
	      addTest: function addTest(e, n, t) {
	        C.push({ name: e, fn: n, options: t });
	      },
	      addAsyncTest: function addAsyncTest(e) {
	        C.push({ name: null, fn: e });
	      }
	    },
	        Modernizr = function Modernizr() {};Modernizr.prototype = S, Modernizr = new Modernizr();
	    var _ = n.documentElement,
	        w = 'svg' === _.nodeName.toLowerCase(),
	        x = 'Moz O ms Webkit',
	        b = S._config.usePrefixes ? x.split(' ') : [];
	    S._cssomPrefixes = b;
	    var E = function E(n) {
	      var r,
	          o = prefixes.length,
	          i = e.CSSRule;
	      if ('undefined' == typeof i) return t;
	      if (!n) return !1;
	      if (n = n.replace(/^@/, ''), r = n.replace(/-/g, '_').toUpperCase() + '_RULE', r in i) return '@' + n;
	      for (var s = 0; o > s; s++) {
	        var a = prefixes[s],
	            l = a.toUpperCase() + '_' + r;
	        if (l in i) return '@-' + a.toLowerCase() + '-' + n;
	      }
	      return !1;
	    };
	    S.atRule = E;
	    var j = S._config.usePrefixes ? x.toLowerCase().split(' ') : [];
	    S._domPrefixes = j;
	    var z = { elem: l('modernizr') };
	    Modernizr._q.push(function () {
	      delete z.elem;
	    });
	    var P = { style: z.elem.style };
	    Modernizr._q.unshift(function () {
	      delete P.style;
	    }), S.testAllProps = g;
	    var N = S.prefixed = function (e, n, t) {
	      return 0 === e.indexOf('@') ? E(e) : (-1 != e.indexOf('-') && (e = s(e)), n ? g(e, n, t) : g(e, 'pfx'));
	    };
	    Modernizr.addTest('objectfit', !!N('objectFit'), {
	      aliases: ['object-fit']
	    }), o(), i(h), delete S.addTest, delete S.addAsyncTest;
	    for (var T = 0; T < Modernizr._q.length; T++) {
	      Modernizr._q[T]();
	    }e.Modernizr = Modernizr;
	  }(window, document);(function (ElementProto) {
	    if (typeof ElementProto.matches !== 'function') {
	      ElementProto.matches = ElementProto.msMatchesSelector || ElementProto.mozMatchesSelector || ElementProto.webkitMatchesSelector || function matches(selector) {
	        var element = this;
	        var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
	        var index = 0;
	
	        while (elements[index] && elements[index] !== element) {
	          ++index;
	        }
	
	        return Boolean(elements[index]);
	      };
	    }
	
	    if (typeof ElementProto.closest !== 'function') {
	      ElementProto.closest = function closest(selector) {
	        var element = this;
	
	        while (element && element.nodeType === 1) {
	          if (element.matches(selector)) {
	            return element;
	          }
	
	          element = element.parentNode;
	        }
	
	        return null;
	      };
	    }
	  })(window.Element.prototype);
	}
	
	if (!Object.entries) {
	  Object.entries = function (obj) {
	    var ownProps = Object.keys(obj),
	        i = ownProps.length,
	        resArray = new Array(i); // preallocate the Array
	    while (i--) {
	      resArray[i] = [ownProps[i], obj[ownProps[i]]];
	    }return resArray;
	  };
	}

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.globalQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(206);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(252);
	
	var _globalState = __webpack_require__(6);
	
	var _globalState2 = _interopRequireDefault(_globalState);
	
	var _header = __webpack_require__(235);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(233);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(606);
	
	var _linkBuilder = __webpack_require__(21);
	
	var _linkBuilder2 = _interopRequireDefault(_linkBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transformCategories = function transformCategories(edges) {
	  var linkFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (node) {
	    return '#';
	  };
	  return edges.filter(function (edge) {
	    return edge.node.count > 0;
	  }).map(function (edge) {
	    return {
	      id: edge.node.wordpress_id,
	      label: edge.node.name,
	      slug: edge.node.slug,
	      lang: edge.node.lang,
	      count: edge.node.count,
	      link: linkFn(edge.node)
	    };
	  });
	};
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper(props) {
	    _classCallCheck(this, TemplateWrapper);
	
	    var articleCategories = transformCategories(props.data.articleCategories.edges, function (node) {
	      return (0, _linkBuilder2.default)({
	        slug: 'post',
	        type: 'static',
	        lang: node.lang,
	        query: {
	          filter: node.slug
	        }
	      });
	    });
	
	    var portfolioCategories = transformCategories(props.data.portfolioCategories.edges, function (node) {
	      return (0, _linkBuilder2.default)({
	        slug: 'portfolio',
	        type: 'static',
	        lang: node.lang,
	        query: {
	          filter: node.slug
	        }
	      });
	    });
	
	    var menu = {};
	    props.data.menu.edges.forEach(function (_ref) {
	      var node = _ref.node;
	
	      menu[node.lang] = node.processedItems;
	    });
	
	    var languages = props.data.languages.edges.map(function (_ref2) {
	      var node = _ref2.node;
	      return node.lang;
	    });
	
	    _globalState2.default.setState({
	      articleCategories: articleCategories,
	      portfolioCategories: portfolioCategories,
	      menu: menu,
	      languages: languages,
	      defaultOpenGraphImage: props.data.options.defaultOGImage
	    });
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  TemplateWrapper.prototype.onWindowResize = function onWindowResize() {
	    _globalState2.default.setState({
	      windowWidth: window.innerWidth
	    });
	  };
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    var defaultNavigateTo = window.___gatsbyNavigateTo = window.___navigateTo;
	
	    var newNavigateTo = function newNavigateTo(pathname) {
	      _globalState2.default.setState({
	        loading: pathname
	      });
	      defaultNavigateTo(pathname);
	    };
	
	    window.___navigateTo = newNavigateTo;
	
	    this.onWindowResize();
	    window.addEventListener('resize', this.onWindowResize, true);
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: 'Brandglow'
	          // meta={[
	          //   { name: 'description', content: 'Sample' },
	          //   { name: 'keywords', content: 'sample, something' },
	          // ]}
	        },
	        _react2.default.createElement('link', {
	          rel: 'apple-touch-icon',
	          sizes: '180x180',
	          href: '/apple-touch-icon.png'
	        }),
	        _react2.default.createElement('link', {
	          rel: 'icon',
	          type: 'image/png',
	          sizes: '32x32',
	          href: '/favicon-32x32.png'
	        }),
	        _react2.default.createElement('link', {
	          rel: 'icon',
	          type: 'image/png',
	          sizes: '16x16',
	          href: '/favicon-16x16.png'
	        }),
	        _react2.default.createElement('link', { rel: 'manifest', href: '/manifest.json' }),
	        _react2.default.createElement('link', { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#761b4a' }),
	        _react2.default.createElement('meta', { name: 'theme-color', content: '#761b4a' })
	      ),
	      children(),
	      _react2.default.createElement(_header2.default, null),
	      _react2.default.createElement(_footer2.default, { options: data.options })
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	var globalQuery = exports.globalQuery = '** extracted graphql fragment **';
	
	exports.default = TemplateWrapper;

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-styles-components----footer-module---footer---3dt86 src-styles-components----container-module---container---1YJKJ","flex":"src-styles-components----footer-module---flex---3v9D4","texts":"src-styles-components----footer-module---texts---3CcQX","footerLogo":"src-styles-components----footer-module---footerLogo---1N0ih","text":"src-styles-components----footer-module---text---1ydrC","socialContainer":"src-styles-components----footer-module---socialContainer---2MY97","socialItem":"src-styles-components----footer-module---socialItem---15g_B"};

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"notInHeader":"src-styles-components----headerFilterSort-module---notInHeader---1bvWw","container":"src-styles-components----headerFilterSort-module---container---1OZuO","list":"src-styles-components----headerFilterSort-module---list---2Kylf","item":"src-styles-components----headerFilterSort-module---item---2Dx6H","itemActive":"src-styles-components----headerFilterSort-module---itemActive---3cT3f src-styles-components----headerFilterSort-module---item---2Dx6H"};

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"logo":"src-styles-components----logo-module---logo---2HgBn"};

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles-components----menu-module---container---3eBRX src-styles-components----container-module---container---1YJKJ","menu":"src-styles-components----menu-module---menu---2h07D","menuOpen":"src-styles-components----menu-module---menuOpen---2noYP src-styles-components----menu-module---menu---2h07D","background":"src-styles-components----menu-module---background---3Bd1S","backgroundLeft":"src-styles-components----menu-module---backgroundLeft---13uhg src-styles-components----menu-module---background---3Bd1S","backgroundRight":"src-styles-components----menu-module---backgroundRight---2Jxx9 src-styles-components----menu-module---background---3Bd1S","menuHidden":"src-styles-components----menu-module---menuHidden---3wYF8 src-styles-components----menu-module---menu---2h07D","menuHover":"src-styles-components----menu-module---menuHover---2ZUEu src-styles-components----menu-module---menu---2h07D","inner":"src-styles-components----menu-module---inner---26hDX","menuItem":"src-styles-components----menu-module---menuItem---1Wq--","menuList":"src-styles-components----menu-module---menuList---2-vAk","menuItemWrapper":"src-styles-components----menu-module---menuItemWrapper---3hYNU","menuLink":"src-styles-components----menu-module---menuLink---1L38p","languages":"src-styles-components----menu-module---languages---2nE6a","languageItem":"src-styles-components----menu-module---languageItem---1Qgz0","submenuArrow":"src-styles-components----menu-module---submenuArrow---2_eHX","submenuArrowExpanded":"src-styles-components----menu-module---submenuArrowExpanded---jQOB2 src-styles-components----menu-module---submenuArrow---2_eHX","itemSubmenuArrow":"src-styles-components----menu-module---itemSubmenuArrow---34iV8","submenuArrowCollapse":"src-styles-components----menu-module---submenuArrowCollapse---2S9Of","submenuArrowExpand":"src-styles-components----menu-module---submenuArrowExpand---3zH_l","itemSubmenu":"src-styles-components----menu-module---itemSubmenu---3Tlt_","itemSubmenuHidden":"src-styles-components----menu-module---itemSubmenuHidden---1SyAV src-styles-components----menu-module---itemSubmenu---3Tlt_","itemSubmenuItem":"src-styles-components----menu-module---itemSubmenuItem---1m4PI","itemSubmenuItemHidden":"src-styles-components----menu-module---itemSubmenuItemHidden---2bBmA src-styles-components----menu-module---itemSubmenuItem---1m4PI"};

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menuButton":"src-styles-components----menuButton-module---menuButton---QuIGM","menuButtonLines":"src-styles-components----menuButton-module---menuButtonLines---M0Ec9","menuHamburgerButton":"src-styles-components----menuButton-module---menuHamburgerButton---3bF2N src-styles-components----menuButton-module---menuButton---QuIGM","menuCloseButton":"src-styles-components----menuButton-module---menuCloseButton---31dSk src-styles-components----menuButton-module---menuButton---QuIGM","menuLoadingButton":"src-styles-components----menuButton-module---menuLoadingButton---3BRjP src-styles-components----menuButton-module---menuButton---QuIGM","spin360Animation":"src-styles-components----menuButton-module---spin360Animation---2aROF","menuAccentLine":"src-styles-components----menuButton-module---menuAccentLine---2Mnd0"};

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapperPosition":"src-styles-components----searchInput-module---wrapperPosition---3Shp_","wrapperPositionOpen":"src-styles-components----searchInput-module---wrapperPositionOpen---39bSc src-styles-components----searchInput-module---wrapperPosition---3Shp_","wrapper":"src-styles-components----searchInput-module---wrapper---_VbI8","wrapperFocus":"src-styles-components----searchInput-module---wrapperFocus---15eQL src-styles-components----searchInput-module---wrapper---_VbI8","searchIcon":"src-styles-components----searchInput-module---searchIcon---1bu4B","input":"src-styles-components----searchInput-module---input---1WB_x"};

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-02a5a7988926b52d9361.js